import { render, staticRenderFns } from "./ArtistCard.vue?vue&type=template&id=28717f76&scoped=true&"
import script from "./ArtistCard.vue?vue&type=script&lang=js&"
export * from "./ArtistCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtistCard.vue?vue&type=style&index=0&id=28717f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28717f76",
  null
  
)

export default component.exports